import React, { Component } from 'react';
import { connect } from 'react-redux';
import '../../utils/innerpage.css'
import { search_calender_action, block_calender_action } from '../../actions/calender_actions/calender_action';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { withRouter } from '../../utils/withRouter';
import { cityActionId, centerActionId, ClientActionId, timeSlotActionId, toastError, toastSuccess } from '../../utils/constants'
import { fill_action } from '../../actions/fillList_action';
import { get_booking_Details_action } from '../../actions/bookingDetails_action/bookingDetails_action';
import moment from 'moment';
import Modal from 'react-bootstrap/Modal';
import Loader from '../../utils/Loader'
import { clearSessionStorage } from '../../utils/constants'
import Pagination from '../../utils/pagination'
import { useEffect, useState } from 'react';
import { useNavigate, Link } from "react-router-dom";
import { data } from 'jquery';
import Dropdown from 'react-dropdown'
import Header from '../../common_components/Header';
import { useRef } from 'react';
/* 
 * mapDispatchToProps
*/
// const mapDispatchToProps = dispatch => ({
//     loginAction: () => dispatch(loginAction())
// })

/* 
 * mapStateToProps
*/
const mapStateToProps = state => ({
    ...state
})


class CalenderView extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isSelectOpen: false,
            isOpen: false,
            isLoading: false,
            isOpen2: false,
            isDatesOverFlow: null,
            calenderList: [],
            dateList: [],
            finalList: [],
            finalDateList: [],
            finalDayList: [],
            holidayArr: [],
            cityId: '',
            venueId: '',
            bookingDate: '',
            timeSlot: [],
            venueList: [],
            venueAddress: '',
            userID: 0,
            venueName: '',
            onShowList: false,
            currentMonth: '',
            currentMonthID: '',
            currentYear: '',
            currentDate: new Date(),
            tempClientList: [],
            isDisplayClientList: false,
            clientName: '',
            bookingList: [],
            selectedIDList: [],
            BlockCalenderList: [],
            clientList: [],
            clientID: '',
            OrderID: '',
            orderNo: '',
            passClientID: '',
            blockedList: [],
            validationDateList: [],
            validationList: [],

            is1stTime: true,
            isEdit: 0,
        }
        this.getCalender = this.getCalender.bind(this)
        this.createFinalList = this.createFinalList.bind(this)
        this.getFillList = this.getFillList.bind(this)
        this.onSelect = this.onSelect.bind(this)
        this.nextMonth = this.nextMonth.bind(this)
        this.prevMonth = this.prevMonth.bind(this)
        this.toggleModal2 = this.toggleModal2.bind(this)
        this.clearSelected = this.clearSelected.bind(this)
        this.onBook = this.onBook.bind(this)
        this.getMonthYear = this.getMonthYear.bind(this)
        this.onClientSelect = this.onClientSelect.bind(this)
        this.handleBlockCalender = this.handleBlockCalender.bind(this)
        this.toggleModal = this.toggleModal.bind(this)
        this.currentDate = this.currentDate.bind(this)
        this.dateCheck = this.dateCheck.bind(this)
        this.onCenterSelect = this.onCenterSelect.bind(this)
        this.renderClientList = this.renderClientList.bind(this)
        this.onClientSearch = this.onClientSearch.bind(this)
        this.getBookingDetails = this.getBookingDetails.bind(this)
        this.renderSlots = this.renderSlots.bind(this)

    }

    componentDidMount() {
        console.log("state", this.props.location.state)
        if (this.props.location.state != null && this.props.location.state.LastDate != null) {
            var date = new Date(`${this.props.location.state.LastDate.slice(3, 5)}/${this.props.location.state.LastDate.slice(0, 2)}/${this.props.location.state.LastDate.slice(6)}`)
        }
        else {
            var date = ''
        }
        const { userID, venueId, selectedIDList, BlockCalenderList } = this.state
        this.setState({
            venueId: this.props.location.state != null && this.props.location.state.centerID != null ? this.props.location.state.centerID : '',
            venueName: this.props.location.state != null && this.props.location.state.venueName != null ? this.props.location.state.venueName : '',
            bookingDate: date,
            passClientID: this.props.location.state != null && this.props.location.state.ClientID != null ? this.props.location.state.ClientID : '',
            OrderID: this.props.location.state != null && this.props.location.state.OrderID != null ? this.props.location.state.OrderID : '',
            isEdit: this.props.location.state != null && this.props.location.state.isEdit != null ? this.props.location.state.isEdit : '',
        })

        if (JSON.parse(sessionStorage.getItem('bookArray')) != null && JSON.parse(sessionStorage.getItem('bookArray')) != '') {
            var list = []
            JSON.parse(sessionStorage.getItem('bookArray')).map((data) => (selectedIDList.push(data.CalendarID)))
            JSON.parse(sessionStorage.getItem('bookArray')).map((data) => (BlockCalenderList.push({
                'calendarID': parseInt(data.CalendarID),
                'clientID': null,
                'timeslotID': data.TimeslotID
            })))
            this.setState({ venueId: JSON.parse(sessionStorage.getItem('bookArray'))[0].CenterID })
            this.setState({ bookingList: JSON.parse(sessionStorage.getItem('bookArray')) })
            JSON.parse(sessionStorage.getItem('bookArray')).map(data => {
                list.push(data.Date)
            })
            this.dateCheck(list)
        }
        if (JSON.parse(sessionStorage.getItem('Is_modify')) == true) {
            // console.log("ooo")
            this.setState({ OrderID: JSON.parse(sessionStorage.getItem('OrderID')) })
            this.setState({ venueId: JSON.parse(sessionStorage.getItem('centerID')) })
            if (JSON.parse(sessionStorage.getItem('navAgain')) != true) {
                sessionStorage.removeItem('bookArray')
                sessionStorage.removeItem('validationDateList')
                // sessionStorage.removeItem('validationList')
                this.setState({ selectedIDList: [], BlockCalenderList: [] })
                if (this.props.location.state != null && this.props.location.state.BookingDate != null) {
                    var list = this.props.location.state.BookingDate.split(',')
                    this.dateCheck(list)
                }
            }
            // console.log("ooo", this.props.location.state)
        }

        var centerIDarr = []
        var centerCodeArr = []
        this.getFillList(centerActionId, userID).then(res1 => {
            res1 && this.getFillList(ClientActionId, userID).then(res2 => {
                this.setState({ isLoading: true })
                res2 && this.state.venueList.length > 0 &&
                    this.state.venueList.map((item => {
                        centerIDarr.push(item.CenterID)
                        centerCodeArr.push(item.Code)
                    }))
                res2 && centerCodeArr.includes(this.props.params.id) ?
                    this.state.venueList.map((item => {
                        this.props.params.id == item.Code &&
                            this.setState({ venueId: item.CenterID })
                    })) :
                    centerIDarr.includes(parseInt(this.props.params.id)) ?
                        this.state.venueList.map((item2 => {
                            this.props.params.id == item2.Code &&
                                this.setState({ venueId: parseInt(this.props.params.id) })
                        })) :
                        this.props.params.id != undefined && this.props.navigate('/calenderView')

                res2 && setTimeout(() => {
                    JSON.parse(sessionStorage.getItem('Is_modify')) ?
                        JSON.parse(sessionStorage.getItem('navAgain')) != true ?
                            this.getBookingDetails().then(res3 => {
                                res3 && sessionStorage.setItem('navAgain', true)
                            }) : this.getCalender().then(res4 => {
                                res4 && this.state.venueList.map((item) => {
                                    if (this.state.venueId == item.CenterID) {
                                        this.setState({ venueName: item.Name })
                                        this.setState({ venueAddress: item.Location })
                                    }
                                })
                            })
                        : this.getCalender().then(res4 => {
                            res4 && this.state.venueList.map((item) => {
                                console.log('item2', this.state.venueId, this.props.location.state)
                                if (this.state.venueId == item.CenterID) {
                                    console.log(item, 'item2')
                                    this.setState({ venueAddress: item.Location })
                                    this.setState({ venueName: item.Name })
                                }
                            })
                        })
                    // this.setState({ isLoading: false })
                }, 200);
            })
        })
    }

    dateCheck(dateList) {
        var res
        var index
        var today = new Date()
        for (var i = 0; i < dateList.length; i++) {
            dateList[i] = moment(`${dateList[i]}`, 'DD-MM-YYYY')
            dateList[i] = new Date(dateList[i].format('YYYY-MM-DD'))
            var diff = Math.floor((dateList[i].getTime() - today.getTime()))
            if (i == 0) {
                res = diff
                index = 0
            }
            else {
                if (res > diff) {
                    res = diff
                    index = i
                }
            }
        }
        var latDate = moment(dateList[index]).format('L')
        this.setState({ bookingDate: latDate })
        // console.log(latDate)
    }

    getFillList(value, userID) {
        this.setState({ isLoading: true })
        return new Promise((resolve, reject) => {
            this.props
                .fill_action(value, (userID == '' || userID == null) ? null : userID)
                .then((data) => {
                    if (data.error != 1) {
                        // if (value == cityActionId) {
                        //     this.setState({ cityList: data.data, isLoading: false })
                        // }
                        if (value == centerActionId) {
                            console.log(data)
                            var list = []
                            for (var i = 0; i < data.data.length; i++) {
                                if (data.data[i].CenterID != 3 && data.data[i].CenterID != 4
                                    // data.data[i].ParentCenterID == 0 || data.data[i].ParentCenterID == null
                                ) {
                                    list.push(data.data[i])
                                }
                            }
                            this.setState({ venueList: list, isLoading: false })
                            resolve(true)
                        }
                        if (value == ClientActionId) {
                            // console.log(data)
                            this.setState({ clientList: data.data, tempClientList: data.data, isLoading: false })
                            resolve(true)
                        }
                        // if (value == timeSlotActionId) {
                        //     var timeARR = []
                        //     for (var i = 0; i < data.data.length; i++) {
                        //         var timeOBJ = {}
                        //         timeOBJ.label = `${data.data[i].FromTime} - ${data.data[i].ToTime}`
                        //         timeOBJ.value = data.data[i].TimeSlotID
                        //         timeARR.push(timeOBJ)
                        //     }
                        //     this.setState({ timeSlotList: timeARR, isLoading: false })
                        // }
                    }
                })
                .catch((e) => {
                    console.log(e);
                });
        })

    }

    // render pincode
    renderClientList() {
        const { clientList, Pincode, tempClientList, clientID } = this.state
        return (
            <ul class="list-group pincode-drop" style={{ position: 'absolute', zIndex: 1 }}>
                {
                    tempClientList.length > 0 && tempClientList.map(data => (
                        <li class="list-group-item" key={Math.random()}
                            onClick={e => this.setState({
                                clientID: data.ClientID,
                                isDisplayClientList: false,
                                clientName: data.Client,
                            })}
                        >{data.Client}</li>

                    ))
                }
            </ul>
        )
    }
    // search 
    onClientSearch(e) {
        const { clientList, tempClientList } = this.state
        // console.log("onClientSearch 123", tempClientList)
        if (e.target.value != '') {
            // console.log(this.state.BlockCalenderList)
            var searchClientList = tempClientList.filter(data => {
                return (
                    data
                        .Client
                        .toLowerCase()
                        .includes(e.target.value.toLowerCase())
                )
            })
            // console.log('pincodeCount', searchClientList.length)
            this.setState({
                clientName: e.target.value,
                // pincodeErr: '',
                tempClientList: searchClientList,
                isDisplayClientList: true
            })
        } else {
            this.setState({
                clientName: e.target.value,
                tempClientList: clientList,
                isDisplayClientList: false
            })
        }
    }

    getCalender() {
        const { cityId, venueId, bookingDate, timeSlot, } = this.state
        this.setState({ isLoading: true })
        return new Promise((resolve, reject) => {
            this.props
                .search_calender_action((cityId == '' || cityId == null) ? null : cityId, (venueId == '' || venueId == null) ? null : venueId, (bookingDate == '' || bookingDate == null) ? null : bookingDate, (timeSlot == '' || timeSlot == null) ? null : timeSlot[0].value, 1)
                .then((data) => {
                    if (data.data.length != 0) {
                        data.data.map(item => {
                            item.ISITMEClient == 1 && console.log("search get data===>", item)
                        })
                        console.log(venueId)
                        if (venueId == '' || venueId == null) {
                            this.setState({ venueAddress: data.data[0].AddressLine1 })
                        }
                        this.createFinalList(data).then(res => {
                            res && resolve(true)
                        })
                        console.log("data from get API==>", data);
                    }
                    else {
                        this.setState({ finalList: [], dateList: [] })
                        this.getMonthYear()
                    }
                })
                .catch((e) => {
                    console.log(e);
                });
        })
    }

    getMonthYear() {
        // console.log(this.state.bookingDate)
        const { bookingDate, currentMonth, currentMonthID, currentYear } = this.state
        var currMonth = currentMonthID
        if (currMonth == 1) {
            this.setState({ currentMonth: 'January' })
        }
        if (currMonth == 2) {
            this.setState({ currentMonth: 'February' })
        }
        if (currMonth == 3) {
            this.setState({ currentMonth: 'March' })
        }
        if (currMonth == 4) {
            this.setState({ currentMonth: 'April' })
        }
        if (currMonth == 5) {
            this.setState({ currentMonth: 'May' })
        }
        if (currMonth == 6) {
            this.setState({ currentMonth: 'June' })
        }
        if (currMonth == 7) {
            this.setState({ currentMonth: 'July' })
        }
        if (currMonth == 8) {
            this.setState({ currentMonth: 'August' })
        }
        if (currMonth == 9) {
            this.setState({ currentMonth: 'September' })
        }
        if (currMonth == 10) {
            this.setState({ currentMonth: 'October' })
        }
        if (currMonth == 11) {
            this.setState({ currentMonth: 'November' })
        }
        if (currMonth == 12) {
            this.setState({ currentMonth: 'December' })
        }
        this.setState({ isLoading: false })
    }

    prevMonth() {
        const { currentMonthID, currentYear } = this.state
        this.setState({ isLoading: true })

        if (currentMonthID == 1) {
            var date = new Date(`12/01/${currentYear - 1}`)
            this.setState({ currentYear: currentYear - 1 })
            this.setState({ currentMonthID: 12 })
        }
        else {
            var date = new Date(`${currentMonthID - 1}/01/${currentYear}`)
            this.setState({ currentMonthID: currentMonthID - 1 })
        }
        this.setState({ bookingDate: date })
        setTimeout(() => {
            this.getCalender()
        }, 200);
    }

    nextMonth() {
        const { currentMonthID, currentYear } = this.state
        this.setState({ isLoading: true })
        if (currentMonthID == 12) {
            var date = new Date(`01/01/${currentYear + 1}`)
            this.setState({ currentYear: currentYear + 1 })
            this.setState({ currentMonthID: 1 })
        }
        else {
            var date = new Date(`${currentMonthID + 1}/01/${currentYear}`)
            this.setState({ currentMonthID: currentMonthID + 1 })
        }
        this.setState({ bookingDate: date })
        setTimeout(() => {
            this.getCalender()
        }, 200);
    }

    async createFinalList(data) {
        const { currentMonthID, is1stTime, bookingDate, dateList, currentYear } = this.state
        var daysArr = []
        var dateArr = []
        var centerArr = []
        var demoARR = []
        var finalARR = []
        var holidayArr = []
        this.setState({ calenderList: data.data })
        return new Promise((resolve, reject) => {


            //centerARR to get corresponding data of center
            //list for no of centers == demoarr
            for (var j = 0; j < data.data.length; j++) {
                if (centerArr.includes(data.data[j].CenterID) == false && data.data[j].CenterID != null) {
                    centerArr.push(data.data[j].CenterID)
                    demoARR.push(data.data[j])
                }
                if (data.data[j].StatusID == 4) {
                    if (!holidayArr.includes(data.data[j].Date)) {
                        holidayArr.push(data.data[j].Date)
                    }
                }
                if (data.data[j].StatusID != 1) {
                    if (JSON.parse(sessionStorage.getItem('Is_modify')) == true) {
                        if (data.data[j].OrderID != this.state.OrderID) {
                            if (data.data[j].ParentCalendarID != null) {
                                if (!this.state.blockedList.includes(data.data[j].ParentCalendarID)) {
                                    this.state.blockedList.push(data.data[j].ParentCalendarID)
                                }
                            }
                            if (data.data[j].ChildCalendarID != null) {
                                var arr = data.data[j].ChildCalendarID.split(',')
                                for (var par = 0; par < arr.length; par++) {
                                    this.state.blockedList.push(parseInt(arr[par]))
                                }
                            }
                        }
                    }
                    else {
                        if (data.data[j].ParentCalendarID != null) {
                            if (!this.state.blockedList.includes(data.data[j].ParentCalendarID)) {
                                this.state.blockedList.push(data.data[j].ParentCalendarID)
                            }
                        }
                        if (data.data[j].ChildCalendarID != null) {
                            var arr = data.data[j].ChildCalendarID.split(',')
                            for (var par = 0; par < arr.length; par++) {
                                this.state.blockedList.push(parseInt(arr[par]))
                            }
                        }
                    }
                }
            }
            // console.log('hol', this.state.blockedList)
            // console.log(demoARR, holidayArr)
            //dateARR to get corresponding days for daysARR
            //list for date and day header == daysArr
            for (var i = 0; i < data.data.length; i++) {
                // var dateOBJ2 = {}
                if (daysArr.includes(data.data[i].Day) == false) {
                    daysArr.push(data.data[i].Day)
                    // dateOBJ2.date = data.data[i].Date
                    // dateOBJ2.day = data.data[i].Day
                    // daysArr.push(dateOBJ2)
                }
            }
            // console.log(daysArr)

            for (var i = 0; i < data.data.length; i++) {
                // var dateOBJ2 = {}
                if (dateArr.includes(data.data[i].Date) == false) {
                    dateArr.push(data.data[i].Date)
                    // dateOBJ2.date = data.data[i].Date
                    // dateOBJ2.day = data.data[i].Day
                    // daysArr.push(dateOBJ2)
                }
            }
            // for (var j = 0; j < data.data.length; j++) {
            // if (data.data[j].CenterID != null) {
            var currMonth = parseInt(dateArr[8].slice(3, 5))
            // break
            // }
            // }
            // console.log(dateArr, currMonth)

            // console.log(currMonth)
            { is1stTime && this.setState({ currentYear: parseInt(dateArr[0].slice(6)) }) }
            { is1stTime && this.setState({ is1stTime: false }) }
            if (currMonth == 1) {
                this.setState({ currentMonth: 'January' })
            }
            if (currMonth == 2) {
                this.setState({ currentMonth: 'February' })
            }
            if (currMonth == 3) {
                this.setState({ currentMonth: 'March' })
            }
            if (currMonth == 4) {
                this.setState({ currentMonth: 'April' })
            }
            if (currMonth == 5) {
                this.setState({ currentMonth: 'May' })
            }
            if (currMonth == 6) {
                this.setState({ currentMonth: 'June' })
            }
            if (currMonth == 7) {
                this.setState({ currentMonth: 'July' })
            }
            if (currMonth == 8) {
                this.setState({ currentMonth: 'August' })
            }
            if (currMonth == 9) {
                this.setState({ currentMonth: 'September' })
            }
            if (currMonth == 10) {
                this.setState({ currentMonth: 'October' })
            }
            if (currMonth == 11) {
                this.setState({ currentMonth: 'November' })
            }
            if (currMonth == 12) {
                this.setState({ currentMonth: 'December' })
            }
            this.setState({ dateList: dateArr })
            //final list to render get with demo arr, days arr and data
            for (var i = 0; i < demoARR.length; i++) {
                var centerObj = {}
                var dateArr2 = []
                var dateARR4 = []
                var s = 0
                var e = 7
                centerObj.isSaturdayOff = demoARR[i].isSaturdayOff
                centerObj.isSundayOff = demoARR[i].isSundayOff
                centerObj.centerID = demoARR[i].CenterID
                centerObj.centerCode = demoARR[i].CenterCode
                centerObj.centerName = demoARR[i].CenterName
                centerObj.url = demoARR[i].URL
                centerObj.cityId = demoARR[i].CityID
                // centerObj.parentcenterID = (demoARR[i].PARENTCENTERID == 0 ? null : demoARR[i].PARENTCENTERID)
                // centerObj.subCenterID = demoARR[i].SubCenterID
                // centerObj.parentcenterName = demoARR[i].ParentCenter
                for (var z = 0; z < Math.ceil(dateArr.length / 7); z++) {
                    var dateARR3 = []
                    var dateOBJ = {}
                    dateArr2 = dateArr.slice(s, e)
                    for (var q = 0; q < dateArr2.length; q++) {
                        var weekOBJ = {}
                        weekOBJ.date = dateArr2[q]
                        weekOBJ.booked = null
                        weekOBJ.dayName = null
                        weekOBJ.ISITMEClient = 0
                        dateARR3.push(weekOBJ)
                    }
                    // console.log('===>', dateARR3)
                    s = s + 7
                    e = e + 7
                    dateOBJ.weekday = dateARR3
                    dateARR4.push(dateOBJ)
                }

                centerObj.week = dateARR4
                finalARR.push(centerObj)
            }
            // console.log(finalARR, finalARR.length)

            if (finalARR.length > 0) {

                for (var i = 0; i < finalARR.length; i++) {
                    for (var j = 0; j < finalARR[i].week.length; j++) {
                        for (var a = 0; a < finalARR[i].week[j].weekday.length; a++) {
                            var eventChildARR = []
                            var eventParentARR = []
                            var statusARR = []
                            for (var k = 0; k < data.data.length; k++) {
                                if (finalARR[i].week[j].weekday[a].date == data.data[k].Date) {
                                    finalARR[i].week[j].weekday[a].dayName = data.data[k].Day
                                }
                                var eventOBJ = {}
                                if (finalARR[i].centerID == data.data[k].CenterID && data.data[k].ParentCalendarID != null) {
                                    if (finalARR[i].week[j].weekday[a].date == data.data[k].Date) {
                                        eventOBJ.Timeslot = data.data[k].Timeslot
                                        eventOBJ.slotID = data.data[k].TimeslotID
                                        eventOBJ.name = data.data[k].TimeSlotName
                                        statusARR.push(data.data[k].StatusID)
                                        eventOBJ.status = data.data[k].StatusID
                                        eventOBJ.stat = data.data[k].Status
                                        eventOBJ.ID = data.data[k].CalendarID
                                        eventOBJ.isLock = data.data[k].IsLock
                                        eventOBJ.orderID = data.data[k].OrderID
                                        if (data.data[k].ISITMEClient == 1) {
                                            finalARR[i].week[j].weekday[a].ISITMEClient = 1
                                        }
                                        eventChildARR.push(eventOBJ)
                                    }
                                }
                                if (finalARR[i].centerID == data.data[k].CenterID && data.data[k].ParentCalendarID == null) {
                                    if (finalARR[i].week[j].weekday[a].date == data.data[k].Date) {
                                        eventOBJ.Timeslot = data.data[k].Timeslot
                                        eventOBJ.name = data.data[k].TimeSlotName
                                        eventOBJ.slotID = data.data[k].TimeslotID
                                        statusARR.push(data.data[k].StatusID)
                                        eventOBJ.status = data.data[k].StatusID
                                        eventOBJ.stat = data.data[k].Status
                                        eventOBJ.ID = data.data[k].CalendarID
                                        eventOBJ.isLock = data.data[k].IsLock
                                        eventOBJ.orderID = data.data[k].OrderID
                                        if (data.data[k].ISITMEClient == 1) {
                                            finalARR[i].week[j].weekday[a].ISITMEClient = 1
                                        }
                                        eventParentARR.push(eventOBJ)
                                    }
                                    // console.log('====>', finalARR[i].week[j].weekday[a])
                                }
                            }
                            if (statusARR.includes(1)) {
                                finalARR[i].week[j].weekday[a].booked = 0
                            }
                            // else {
                            //     finalARR[i].week[j].weekday[a].booked = 1
                            // }
                            finalARR[i].week[j].weekday[a].eventListChild = eventChildARR
                            finalARR[i].week[j].weekday[a].eventListParent = eventParentARR
                        }
                    }
                }
            }
            // console.log(holidayArr)


            if (this.state.venueId == '' || this.state.venueId == null) {
                this.setState({ venueId: finalARR[0].centerID })
                this.setState({ venueName: finalARR[0].centerName })
            }
            var finalListt = []
            if (finalARR.length > 0) {
                finalListt.push(finalARR[0])
            }


            for (var i = 0; i < finalListt.length; i++) {
                for (var j = 0; j < finalListt[i].week.length; j++) {
                    for (var z = 0; z < finalListt[i].week[j].weekday.length; z++) {
                        finalListt[i].week[j].weekday[z].noOfSlots = finalListt[i].week[j].weekday[z].eventListChild.length
                        for (var a = 0; a < finalListt[i].week[j].weekday[z].eventListChild.length; a++) {
                            finalListt[i].week[j].weekday[z].eventListChild[a].slotNo = a
                            finalListt[i].week[j].weekday[z].eventListChild[a].isParent = 0
                            finalListt[i].week[j].weekday[z].eventListChild[a].isSelected = false

                        }
                        for (var a = 0; a < finalListt[i].week[j].weekday[z].eventListParent.length; a++) {
                            finalListt[i].week[j].weekday[z].eventListParent[a].isParent = 1
                            finalListt[i].week[j].weekday[z].eventListParent[a].isSelected = false
                        }
                    }
                }
            }
            // console.log('heeeee', finalListt)

            // if (this.state.isComingFromDiffPage) {
            // var dateList = []
            if (this.state.selectedIDList.length > 0) {
                for (var i = 0; i < finalListt.length; i++) {
                    for (var j = 0; j < finalListt[i].week.length; j++) {
                        for (var z = 0; z < finalListt[i].week[j].weekday.length; z++) {
                            for (var x = 0; x < this.state.selectedIDList.length; x++) {
                                for (var k = 0; k < finalListt[i].week[j].weekday[z].eventListChild.length; k++) {
                                    if (this.state.selectedIDList[x] == finalListt[i].week[j].weekday[z].eventListChild[k].ID) {
                                        if (!this.state.validationDateList.includes(finalListt[i].week[j].weekday[z].date)) {
                                            this.state.validationDateList.push(finalListt[i].week[j].weekday[z].date)
                                            this.state.validationList.push(finalListt[i].week[j].weekday[z])
                                        }
                                    }
                                }
                                for (var k = 0; k < finalListt[i].week[j].weekday[z].eventListParent.length; k++) {
                                    if (this.state.selectedIDList[x] == finalListt[i].week[j].weekday[z].eventListParent[k].ID) {
                                        if (!this.state.validationDateList.includes(finalListt[i].week[j].weekday[z].date)) {
                                            this.state.validationDateList.push(finalListt[i].week[j].weekday[z].date)
                                            this.state.validationList.push(finalListt[i].week[j].weekday[z])
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }

            for (var a = 0; a < this.state.validationList.length; a++) {
                for (var b = 0; b < this.state.validationList[a].eventListChild.length; b++) {
                    if (this.state.selectedIDList.includes(this.state.validationList[a].eventListChild[b].ID)) {
                        this.state.validationList[a].eventListChild[b].isSelected = true

                    }
                }
                for (var b = 0; b < this.state.validationList[a].eventListParent.length; b++) {
                    if (this.state.selectedIDList.includes(this.state.validationList[a].eventListParent[b].ID)) {
                        this.state.validationList[a].eventListParent[b].isSelected = true
                    }
                }
            }
            // console.log(this.state.validationList)

            if (JSON.parse(sessionStorage.getItem('validationDateList')) != null && JSON.parse(sessionStorage.getItem('validationDateList')).length > 0) {
                var differentDates = []
                var datePlus = false
                var dateMinus = false
                var valid1stDate = new Date(moment(this.state.validationDateList[0], 'DD-MM-YYYY').format('YYYY-MM-DD'))
                for (var i = 0; i < JSON.parse(sessionStorage.getItem('validationDateList')).length; i++) {
                    if (!this.state.validationDateList.includes(JSON.parse(sessionStorage.getItem('validationDateList'))[i])) {
                        differentDates.push(JSON.parse(sessionStorage.getItem('validationDateList'))[i])
                    }
                }
                if (differentDates.length > 0) {
                    for (var i = 0; i < differentDates.length; i++) {
                        var diffDate = new Date(moment(differentDates[i], 'DD-MM-YYYY').format('YYYY-MM-DD'))
                        if (Math.sign(Math.abs(diffDate.getTime() - valid1stDate.getTime()) / (1000 * 3600 * 24)) == 1) {
                            datePlus = true
                        }
                        else if (Math.sign(Math.abs(diffDate.getTime() - valid1stDate.getTime()) / (1000 * 3600 * 24)) == -1) {
                            dateMinus = true
                        }
                    }
                    if (datePlus == true && dateMinus == false) {
                        this.setState({ isDatesOverFlow: 1 })
                    }
                    else if (datePlus == false && dateMinus == true) {
                        this.setState({ isDatesOverFlow: 2 })
                    }
                    else if (datePlus == true && dateMinus == true) {
                        this.setState({ isDatesOverFlow: 3 })
                    }
                    else {
                        this.setState({ isDatesOverFlow: null })
                    }
                }
                else {
                    this.setState({ isDatesOverFlow: null })
                }
            }
            else {
                this.setState({ isDatesOverFlow: null })
            }

            this.setState({ finalList: finalListt })
            this.setState({ holidayArr: holidayArr })
            this.setState({ currentMonthID: currMonth })
            // console.log(holidayArr, finalListt, this.state.validationList)


            setTimeout(() => {
                // console.log(JSON.parse(sessionStorage.getItem('bookArray')), this.state.selectedIDList, this.state.BlockCalenderList)
                this.setState({ finalDateList: dateArr })
                this.setState({ finalDayList: daysArr })
                this.setState({ isLoading: false })
                resolve(true)
                // console.log("days", daysArr)
                // console.log("date", dateArr)
                // console.log("center", centerArr)
                // console.log("center info", this.state.venueId)
                console.log("final list to populate the table", this.state.finalList)
                // console.log("!!!!!!!;", new Date(`${finalARR[0].week[0].weekday[0].date.slice(3, 5)}/${finalARR[0].week[0].weekday[0].date.slice(0, 2)}/${finalARR[0].week[0].weekday[0].date.slice(6)}`))
                // console.log(this.state.finalList[0].week)
            }, 500);
        })
    }

    getBookingDetails() {
        var id = JSON.parse(sessionStorage.getItem('OrderID'))
        return new Promise((resolve, reject) => {
            this.props
                .get_booking_Details_action(id)
                .then((data) => {
                    console.log(data)
                    if (data.error != 1) {
                        var arr = data.data.tableData
                        sessionStorage.setItem('bookArray', JSON.stringify(arr))
                        JSON.parse(sessionStorage.getItem('bookArray')).map((data) => (this.state.selectedIDList.push(data.CalendarID)))
                        JSON.parse(sessionStorage.getItem('bookArray')).map((data) => (this.state.bookingList.push(data)))
                        this.getCalender()
                        resolve(true)
                    }
                })
                .catch((e) => {
                    console.log(e);
                });
        })
    }

    selectValidation(id, type) {
        const { selectedCenter, finalList, isDatesOverFlow, selectedIDList, validationDateList, validationList, BlockCalenderList, bookingList, calenderList } = this.state
        var obj = {}
        var err = false
        // var validationDateList = []
        var currentDate
        var validObj
        // var ifDateCanBeRemoved = false
        var toBeTrue = []
        var toBeFalse = []

        // var dumArr = validationList
        if (validationList.length > 0) {
            for (var a = 0; a < validationList.length; a++) {
                if (!validationDateList.includes(validationList[a].date)) {
                    validationDateList.push(validationList[a].date)
                }
            }
        }
        for (var a = 0; a < finalList.length; a++) {
            for (var b = 0; b < finalList[a].week.length; b++) {
                for (var z = 0; z < finalList[a].week[b].weekday.length; z++) {
                    for (var c = 0; c < finalList[a].week[b].weekday[z].eventListChild.length; c++) {
                        // console.log(finalList[a].days[b])
                        if (parseInt(id) == finalList[a].week[b].weekday[z].eventListChild[c].ID) {
                            currentDate = finalList[a].week[b].weekday[z].date
                            validObj = finalList[a].week[b].weekday[z]
                        }
                    }
                    for (var c = 0; c < finalList[a].week[b].weekday[z].eventListParent.length; c++) {
                        if (parseInt(id) == finalList[a].week[b].weekday[z].eventListParent[c].ID) {
                            currentDate = finalList[a].week[b].weekday[z].date
                            validObj = finalList[a].week[b].weekday[z]
                        }
                    }
                }
            }
        }
        if (validationList.length == 0) {
            validationDateList.push(currentDate)
            // console.log('checck', validationList)
            for (var a = 0; a < finalList.length; a++) {
                for (var b = 0; b < finalList[a].week.length; b++) {
                    for (var z = 0; z < finalList[a].week[b].weekday.length; z++) {
                        for (var c = 0; c < finalList[a].week[b].weekday[z].eventListChild.length; c++) {
                            // console.log(finalList[a].days[b])
                            if (parseInt(id) == finalList[a].week[b].weekday[z].eventListChild[c].ID) {
                                finalList[a].week[b].weekday[z].eventListChild[c].isSelected = true
                                validationList.push(finalList[a].week[b].weekday[z])
                            }
                        }
                        for (var c = 0; c < finalList[a].week[b].weekday[z].eventListParent.length; c++) {
                            if (parseInt(id) == finalList[a].week[b].weekday[z].eventListParent[c].ID) {
                                finalList[a].week[b].weekday[z].eventListParent[c].isSelected = true
                                validationList.push(finalList[a].week[b].weekday[z])
                            }
                        }
                    }
                }
            }
        }
        else {
            if (type == 0) {
                toBeFalse.push(parseInt(id))
                if (!validationDateList.includes(currentDate)) {

                    // ifDateCanBeRemoved = true
                    validationDateList.push(currentDate)
                    for (var a = 0; a < validObj.eventListChild.length; a++) {
                        if (parseInt(id) == validObj.eventListChild[a].ID) {
                            validObj.eventListChild[a].isSelected = true
                            validationList.push(validObj)
                        }
                    }
                    for (var a = 0; a < validObj.eventListParent.length; a++) {
                        if (parseInt(id) == validObj.eventListParent[a].ID) {
                            validObj.eventListParent[a].isSelected = true
                            validationList.push(validObj)
                        }
                    }
                }
                else {
                    // console.log(validObj)
                    for (var x = 0; x < validationList.length; x++) {
                        if (currentDate == validationList[x].date) {
                            for (var a = 0; a < validationList[x].eventListChild.length; a++) {
                                if (parseInt(id) == validationList[x].eventListChild[a].ID) {
                                    validationList[x].eventListChild[a].isSelected = true
                                    for (var b = 0; b < validationList[x].eventListParent.length; b++) {
                                        if (validationList[x].eventListParent[b].isSelected == true) {
                                            validationList[x].eventListParent[b].isSelected = false
                                            toBeTrue.push(validationList[x].eventListParent[b].ID)
                                        }
                                    }
                                }
                            }
                            for (var a = 0; a < validationList[x].eventListParent.length; a++) {
                                if (parseInt(id) == validationList[x].eventListParent[a].ID) {
                                    validationList[x].eventListParent[a].isSelected = true
                                    for (var b = 0; b < validationList[x].eventListChild.length; b++) {
                                        if (validationList[x].eventListChild[b].isSelected == true) {
                                            validationList[x].eventListChild[b].isSelected = false
                                            toBeTrue.push(validationList[x].eventListChild[b].ID)
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
            else {
                // console.log('checck', validationList, JSON.parse(sessionStorage.getItem('bookArray')))
                toBeTrue.push(parseInt(id))
                for (var x = 0; x < validationList.length; x++) {
                    if (currentDate == validationList[x].date) {
                        // console.log(validationList[x])
                        for (var a = 0; a < validationList[x].eventListChild.length; a++) {
                            if (parseInt(id) == validationList[x].eventListChild[a].ID) {
                                validationList[x].eventListChild[a].isSelected = false

                            }
                        }
                        for (var a = 0; a < validationList[x].eventListParent.length; a++) {
                            if (parseInt(id) == validationList[x].eventListParent[a].ID) {
                                validationList[x].eventListParent[a].isSelected = false
                            }
                        }
                    }
                }
            }
        }
        for (var i = 0; i < validationList.length; i++) {
            for (var j = 0; j < validationList.length - i - 1; j++) {
                var dateA = new Date(moment(validationList[j].date, 'DD-MM-YYYY').format('YYYY-MM-DD'))
                var dateB = new Date(moment(validationList[j + 1].date, 'DD-MM-YYYY').format('YYYY-MM-DD'))
                if (dateA > dateB) {
                    var tempvalidationList = validationList[j]
                    var tempvalidationDateList = validationDateList[j]
                    validationList[j] = validationList[j + 1]
                    validationDateList[j] = validationDateList[j + 1]
                    validationList[j + 1] = tempvalidationList
                    validationDateList[j + 1] = tempvalidationDateList
                }
            }
        }
        // console.log('vefore======>', validationList, toBeFalse, toBeTrue)

        //checking
        var ERROR = false
        var startSlot = 0
        var endSlot = 0
        // var dumm = [0, 1, 1, 1, 0, 0, 0]
        // if (type == 0) {
        if (validationList.length == 1) {
            if (validationList[0].eventListParent[0].isSelected) {
                startSlot = 1
                endSlot = 1
            }
            else {
                for (var a = 0; a < validationList[0].eventListChild.length; a++) {
                    if (validationList[0].eventListChild[a].isSelected == true) {
                        startSlot = 1
                        for (var b = a; b < validationList[0].eventListChild.length; b++) {
                            if (validationList[0].eventListChild[b].isSelected == false) {
                                endSlot = 1
                                for (var c = b; c < validationList[0].eventListChild.length; c++) {
                                    if (validationList[0].eventListChild[c].isSelected == true) {
                                        ERROR = true
                                        break
                                    }
                                }
                                break
                            }
                        }
                        break
                    }
                }
            }
        }
        else if (validationList.length == 2) {
            // console.log('err', validationDateList)
            for (var a = 0; a < validationDateList.length; a++) {
                if (validationDateList[a + 1] != undefined) {
                    var date1 = new Date(moment(validationDateList[a], 'DD-MM-YYYY').format('YYYY-MM-DD'))
                    var date2 = new Date(moment(validationDateList[a + 1], 'DD-MM-YYYY').format('YYYY-MM-DD'))
                    if ((Math.abs(date2.getTime() - date1.getTime()) / (1000 * 3600 * 24)) > 1 || (Math.abs(date2.getTime() - date1.getTime()) / (1000 * 3600 * 24)) < -1) {
                        // console.log("err here")
                        ERROR = true
                        break
                    }
                }
            }
            if (validationList[0].eventListParent[0].isSelected == true) {
                startSlot = 1
            }
            else {
                for (var a = 0; a < validationList[0].eventListChild.length; a++) {
                    if (validationList[0].eventListChild[a].isSelected == true) {
                        startSlot = 1
                        for (var b = a; b < validationList[0].eventListChild.length; b++) {
                            if (validationList[0].eventListChild[b].isSelected == false) {
                                ERROR = true
                                break
                            }
                        }
                        break
                    }
                }
            }
            if (validationList[1].eventListParent[0].isSelected == true) {
                endSlot = 1
            }
            else {
                for (var a = validationList[1].eventListChild.length - 1; a >= 0; a--) {
                    if (validationList[1].eventListChild[a].isSelected == true) {
                        endSlot = 1
                        for (var b = a; b >= 0; b--) {
                            if (validationList[1].eventListChild[b].isSelected == false) {
                                ERROR = true
                                break
                            }
                        }
                        break
                    }
                }
            }
        }
        else {
            for (var a = 0; a < validationDateList.length; a++) {
                if (validationDateList[a + 1] != undefined) {
                    var date1 = new Date(moment(validationDateList[a], 'DD-MM-YYYY').format('YYYY-MM-DD'))
                    var date2 = new Date(moment(validationDateList[a + 1], 'DD-MM-YYYY').format('YYYY-MM-DD'))
                    if ((Math.abs(date2.getTime() - date1.getTime()) / (1000 * 3600 * 24)) > 1 || (Math.abs(date2.getTime() - date1.getTime()) / (1000 * 3600 * 24)) < -1) {
                        ERROR = true
                        break
                    }
                }
            }
            if (validationList[0].eventListParent[0].isSelected == true) {
                startSlot = 1
            }
            else {
                for (var a = 0; a < validationList[0].eventListChild.length; a++) {
                    if (validationList[0].eventListChild[a].isSelected == true) {
                        startSlot = 1
                        for (var b = a; b < validationList[0].eventListChild.length; b++) {
                            if (validationList[0].eventListChild[b].isSelected == false) {
                                ERROR = true
                                break
                            }
                        }
                        break
                    }
                }
            }
            if (validationList[validationList.length - 1].eventListParent[0].isSelected == true) {
                endSlot = 1
            }
            else {
                for (var a = validationList[validationList.length - 1].eventListChild.length - 1; a >= 0; a--) {
                    if (validationList[validationList.length - 1].eventListChild[a].isSelected == true) {
                        endSlot = 1
                        for (var b = a; b >= 0; b--) {
                            if (validationList[validationList.length - 1].eventListChild[b].isSelected == false) {
                                ERROR = true
                                break
                            }
                        }
                        break
                    }
                }
            }
            for (var a = 1; a < validationList.length - 1; a++) {
                if (validationList[a].eventListParent[0].isSelected != true) {
                    // else {
                    for (var b = 0; b < validationList[a].eventListChild.length; b++) {
                        if (validationList[a].eventListChild[b].isSelected == false) {
                            ERROR = true
                            break
                        }
                    }
                    // }
                }
            }

        }

        // console.log('isDatesOverFlow', isDatesOverFlow)
        if (validationList.length > 1) {

            if (isDatesOverFlow == 1) {
                if (currentDate == validationList[validationList.length - 1].date) {
                    for (var a = 0; a < validationList[validationList.length - 1].eventListParent.length; a++) {
                        if (validationList[validationList.length - 1].eventListParent[a].isSelected != true) {
                            for (var b = 0; b < validationList[validationList.length - 1].eventListChild.length; b++) {
                                if (validationList[validationList.length - 1].eventListChild[b].isSelected != true) {
                                    ERROR = true
                                    break
                                }
                            }
                        }
                    }
                }
            }
            else if (isDatesOverFlow == 2) {
                if (currentDate == validationList[0].date) {
                    for (var a = 0; a < validationList[0].eventListParent.length; a++) {
                        if (validationList[0].eventListParent[a].isSelected != true) {
                            for (var b = 0; b < validationList[0].eventListChild.length; b++) {
                                if (validationList[0].eventListChild[b].isSelected != true) {
                                    ERROR = true
                                    break
                                }
                            }
                        }
                    }
                }
            }
            else if (isDatesOverFlow == 3) {
                if (currentDate == validationList[0].date) {
                    for (var a = 0; a < validationList[0].eventListParent.length; a++) {
                        if (validationList[0].eventListParent[a].isSelected != true) {
                            for (var b = 0; b < validationList[0].eventListChild.length; b++) {
                                if (validationList[0].eventListChild[b].isSelected != true) {
                                    ERROR = true
                                    break
                                }
                            }
                        }
                    }
                }
                else if (currentDate == validationList[validationList.length - 1].date) {
                    for (var a = 0; a < validationList[validationList.length - 1].eventListParent.length; a++) {
                        if (validationList[validationList.length - 1].eventListParent[a].isSelected != true) {
                            for (var b = 0; b < validationList[validationList.length - 1].eventListChild.length; b++) {
                                if (validationList[validationList.length - 1].eventListChild[b].isSelected != true) {
                                    ERROR = true
                                    break
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            if (isDatesOverFlow == 1) {
                if (validationList[0].eventListParent[0].isSelected != true) {
                    for (var a = 0; a < validationList[0].eventListChild.length; a++) {
                        if (validationList[0].eventListChild[a].isSelected == true) {
                            for (var b = a; b < validationList[0].eventListChild.length; b++) {
                                if (validationList[0].eventListChild[b].isSelected == false) {
                                    ERROR = true
                                    break
                                }
                            }
                            break
                        }
                    }
                }
            }
            if (isDatesOverFlow == 2) {
                if (validationList[validationList.length - 1].eventListParent[0].isSelected != true) {
                    for (var a = validationList[validationList.length - 1].eventListChild.length - 1; a >= 0; a--) {
                        if (validationList[validationList.length - 1].eventListChild[a].isSelected == true) {
                            for (var b = a; b >= 0; b--) {
                                if (validationList[validationList.length - 1].eventListChild[b].isSelected == false) {
                                    ERROR = true
                                    break
                                }
                            }
                            break
                        }
                    }
                }
            }
        }
        for (var a = 0; a < validationDateList.length; a++) {
            if (validationDateList[a + 1] != undefined) {
                var date1 = new Date(moment(validationDateList[a], 'DD-MM-YYYY').format('YYYY-MM-DD'))
                var date2 = new Date(moment(validationDateList[a + 1], 'DD-MM-YYYY').format('YYYY-MM-DD'))
                if ((Math.abs(date2.getTime() - date1.getTime()) / (1000 * 3600 * 24)) > 1 || (Math.abs(date2.getTime() - date1.getTime()) / (1000 * 3600 * 24)) < -1) {
                    ERROR = true
                    break
                }
            }
        }
        if (ERROR == true) {
            // if (ifDateCanBeRemoved) {
            //     for (var a = 0; a < validationList.length; a++) {
            //         if (currentDate == validationList[a].day) {
            //             validationList.splice(a, 1)
            //             validationDateList.splice(a, 1)
            //         }
            //     }
            // }
            // else {
            // console.log(toBeFalse, toBeTrue)
            for (var a = 0; a < validationList.length; a++) {
                if (currentDate == validationList[a].date) {
                    for (var b = 0; b < validationList[a].eventListChild.length; b++) {
                        if (toBeTrue.includes(validationList[a].eventListChild[b].ID)) {
                            validationList[a].eventListChild[b].isSelected = true
                        }
                        if (toBeFalse.includes(validationList[a].eventListChild[b].ID)) {
                            validationList[a].eventListChild[b].isSelected = false
                        }
                    }
                    for (var b = 0; b < validationList[a].eventListParent.length; b++) {
                        if (toBeTrue.includes(validationList[a].eventListParent[b].ID)) {
                            validationList[a].eventListParent[b].isSelected = true
                        }
                        if (toBeFalse.includes(validationList[a].eventListParent[b].ID)) {
                            validationList[a].eventListParent[b].isSelected = false
                        }
                    }
                }
            }
            for (var a = 0; a < validationList.length; a++) {
                // console.log('1', validationDateList, validationList)
                var checkforisSelectArr = []
                if (validationList[a].eventListParent[0].isSelected != true) {
                    for (var b = 0; b < validationList[a].eventListChild.length; b++) {
                        checkforisSelectArr.push(validationList[a].eventListChild[b].isSelected)
                    }
                    if (!checkforisSelectArr.includes(true)) {
                        validationList.splice(a, 1)
                        validationDateList.splice(a, 1)
                    }
                }
            }
            // }
        }
        else {
            for (var a = 0; a < validationList.length; a++) {
                var checkforisSelectArr = []
                // console.log('2', validationDateList, validationList)

                if (validationList[a].eventListParent[0].isSelected != true) {
                    for (var b = 0; b < validationList[a].eventListChild.length; b++) {
                        checkforisSelectArr.push(validationList[a].eventListChild[b].isSelected)
                    }
                    if (!checkforisSelectArr.includes(true)) {
                        validationList.splice(a, 1)
                        validationDateList.splice(a, 1)
                    }
                }
            }

        }
        // this.setState({ validationDateList: validationDateList })
        sessionStorage.setItem('validationDateList', JSON.stringify(validationDateList))

        setTimeout(() => {

            // console.log('after======>', validationDateList, JSON.parse(sessionStorage.getItem('validationDateList')), validationList, ERROR)
        }, 250);

        return ERROR

    }

    onSelect(selectedValue) {
        const { venueId, selectedIDList, finalList, BlockCalenderList, validationDateList, validationList, bookingList, calenderList } = this.state

        this.setState({ isSelectOpen: false })
        var calendarID
        var clientID = null
        var timeslotID
        if (!selectedIDList.includes(parseInt(selectedValue))) {
            var tempIDlist = []
            for (var a = 0; a < bookingList.length; a++) {
                tempIDlist.push(parseInt(bookingList[a].CalendarID))
            }
            tempIDlist.push(parseInt(selectedValue))
            var otherChildArr = []
            var otherchildIncludes = true
            var parentID = null
            // var fullSlotsPresent = false
            var centerID = null
            console.log(calenderList, tempIDlist)
            console.log('============>>>', selectedValue)
            for (var s = 0; s < calenderList.length; s++) {
                if (parseInt(calenderList[s].CalendarID) == selectedValue) {
                    parentID = parseInt(calenderList[s].ParentCalendarID)
                    centerID = parseInt(calenderList[s].CenterID)
                }
            }
            for (var s = 0; s < finalList.length; s++) {
                if (parseInt(calenderList[s].CalendarID) == selectedValue) {
                    parentID = parseInt(calenderList[s].ParentCalendarID)
                    centerID = parseInt(calenderList[s].CenterID)
                }
            }

            //creating arr to check all childs
            for (var s = 0; s < calenderList.length; s++) {
                if (parentID == calenderList[s].ParentCalendarID && parentID != null) {
                    otherChildArr.push(calenderList[s].CalendarID)
                }
            }
            if (parentID != null) {
                if (otherChildArr.length > 0) {
                    for (var t = 0; t < otherChildArr.length; t++) {
                        // console.log('1selectedIDList===>', tempIDlist.includes(otherChildArr[t]))
                        if (!tempIDlist.includes(otherChildArr[t])) {
                            // console.log('2===>', otherChildArr, otherchildIncludes, selectedIDList)
                            otherchildIncludes = false
                            break
                        }
                    }
                } else {
                    otherchildIncludes = false
                }
            } else {
                otherchildIncludes = false
            }

            if (otherchildIncludes) {
                for (var a = 0; a < calenderList.length; a++) {
                    if (selectedValue == calenderList[a].CalendarID) {
                        bookingList.push(calenderList[a])
                        calendarID = selectedValue
                        timeslotID = calenderList[a].TimeslotID
                        BlockCalenderList.push({
                            'calendarID': parseInt(calendarID),
                            'clientID': clientID,
                            'timeslotID': timeslotID
                        })
                        selectedIDList.push(parseInt(selectedValue))
                    }
                }
                selectedValue = parentID
                var res = this.selectValidation(selectedValue, 0)
                if (res == false) {
                    for (var a = 0; a < calenderList.length; a++) {
                        if (selectedValue == calenderList[a].CalendarID) {
                            bookingList.push(calenderList[a])
                            calendarID = selectedValue
                            timeslotID = calenderList[a].TimeslotID
                            BlockCalenderList.push({
                                'calendarID': parseInt(calendarID),
                                'clientID': clientID,
                                'timeslotID': timeslotID
                            })
                            selectedIDList.push(parseInt(selectedValue))
                            // console.log('finalss===>', this.state.bookingList, selectedIDList, BlockCalenderList, tempIDlist, otherChildArr)
                            for (var t = 0; t < otherChildArr.length; t++) {
                                for (var s = 0; s < selectedIDList.length; s++) {
                                    if (otherChildArr[t] == selectedIDList[s]) {
                                        selectedIDList.splice(s, 1)
                                        bookingList.splice(s, 1)
                                        BlockCalenderList.splice(s, 1)
                                    }
                                }
                            }
                        }
                    }
                }
                else {
                    this.toggleModal2()
                }
            } else {
                var res = this.selectValidation(selectedValue, 0)
                // console.log(res)
                if (res == false) {
                    for (var a = 0; a < calenderList.length; a++) {
                        if (selectedValue == calenderList[a].CalendarID) {
                            bookingList.push(calenderList[a])
                            calendarID = selectedValue
                            timeslotID = calenderList[a].TimeslotID
                            BlockCalenderList.push({
                                'calendarID': parseInt(calendarID),
                                'clientID': clientID,
                                'timeslotID': timeslotID
                            })
                            if (calenderList[a].ParentCalendarID != null) {
                                for (var s = 0; s < selectedIDList.length; s++) {
                                    if (calenderList[a].ParentCalendarID == selectedIDList[s]) {
                                        selectedIDList.splice(s, 1)
                                        bookingList.splice(s, 1)
                                        BlockCalenderList.splice(s, 1)
                                    }
                                }
                            }

                            if (calenderList[a].ChildCalendarID != null) {
                                var arr = calenderList[a].ChildCalendarID.split(',')
                                for (var par = 0; par < arr.length; par++) {
                                    arr[par] = parseInt(arr[par])
                                }
                                for (var l = 0; l < arr.length; l++) {
                                    for (var q = 0; q < selectedIDList.length; q++) {
                                        if (arr[l] == selectedIDList[q]) {
                                            selectedIDList.splice(q, 1)
                                            bookingList.splice(q, 1)
                                            BlockCalenderList.splice(q, 1)
                                        }
                                    }
                                }
                            }
                            selectedIDList.push(parseInt(selectedValue))
                        }
                    }
                }
                else {
                    this.toggleModal2()
                }
            }
        }
        // if (!selectedIDList.includes(parseInt(selectedValue))) {
        //     var res = this.selectValidation(selectedValue, 0)
        //     if (res == false) {

        //         for (var a = 0; a < calenderList.length; a++) {
        //             if (selectedValue == calenderList[a].CalendarID) {
        //                 // var selectedDate = new Date(moment(calenderList[a].Date, 'DD-MM-YYYY').format('YYYY-MM-DD'))
        //                 // var showmodal = false
        //                 // if (bookingList.length > 0) {
        //                 // for (var t = 0; t < bookingList.length; t++) {
        //                 // var bookingListDate = new Date(moment(bookingList[t].Date, 'DD-MM-YYYY').format('YYYY-MM-DD'))
        //                 // if ((Math.abs(selectedDate.getTime() - bookingListDate.getTime()) / (1000 * 3600 * 24)) == 1 || (Math.abs(selectedDate.getTime() - bookingListDate.getTime()) / (1000 * 3600 * 24)) == 0) {
        //                 // console.log(Math.abs(selectedDate.getTime() - bookingListDate.getTime()) / (1000 * 3600 * 24))
        //                 bookingList.push(calenderList[a])
        //                 calendarID = selectedValue
        //                 timeslotID = calenderList[a].TimeslotID
        //                 BlockCalenderList.push({
        //                     'calendarID': parseInt(calendarID),
        //                     'clientID': clientID,
        //                     'timeslotID': timeslotID
        //                 })
        //                 if (calenderList[a].ParentCalendarID != null) {
        //                     for (var s = 0; s < selectedIDList.length; s++) {
        //                         if (calenderList[a].ParentCalendarID == selectedIDList[s]) {
        //                             selectedIDList.splice(s, 1)
        //                             bookingList.splice(s, 1)
        //                             BlockCalenderList.splice(s, 1)
        //                         }
        //                     }
        //                 }

        //                 if (calenderList[a].ChildCalendarID != null) {
        //                     var arr = calenderList[a].ChildCalendarID.split(',')
        //                     for (var par = 0; par < arr.length; par++) {
        //                         arr[par] = parseInt(arr[par])
        //                     }
        //                     for (var l = 0; l < arr.length; l++) {
        //                         for (var q = 0; q < selectedIDList.length; q++) {
        //                             if (arr[l] == selectedIDList[q]) {
        //                                 selectedIDList.splice(q, 1)
        //                                 bookingList.splice(q, 1)
        //                                 BlockCalenderList.splice(q, 1)
        //                             }
        //                         }
        //                     }
        //                 }
        //                 selectedIDList.push(parseInt(selectedValue))
        //                 // showmodal = false
        //                 // break
        //                 // }
        //                 // }
        //                 // if (showmodal) {
        //                 //     this.toggleModal2()
        //                 // }
        //                 // }
        //             }
        //         }
        //     }
        //     else {
        //         this.toggleModal2()
        //     }
        // }
        else {
            var res = this.selectValidation(selectedValue, 1)
            if (res == false) {

                for (var i = 0; i < selectedIDList.length; i++) {
                    if (selectedValue == selectedIDList[i]) {
                        // console.log('hh', bookingList)
                        // if (i == 0 || i == selectedIDList.length - 1) {
                        selectedIDList.splice(i, 1)
                        bookingList.splice(i, 1)
                        BlockCalenderList.splice(i, 1)
                        // }
                        // else {
                        //     this.toggleModal2()
                        // }
                    }
                }
                // console.log('hh', bookingList)

            }
            else {
                this.toggleModal2()
            }
        }

        if (selectedIDList.length == 0) {
            this.setState({ venueId: '' })
        }
        else {
            for (var i = 0; i < calenderList.length; i++) {
                if (selectedValue == calenderList[i].CalendarID) {
                    this.setState({ venueId: calenderList[i].CenterID })
                }
            }
        }

        for (var i = 0; i < bookingList.length; i++) {
            for (var j = 0; j < bookingList.length - i - 1; j++) {
                var dateA = new Date(moment(bookingList[j].Date, 'DD-MM-YYYY').format('YYYY-MM-DD'))
                var dateB = new Date(moment(bookingList[j + 1].Date, 'DD-MM-YYYY').format('YYYY-MM-DD'))
                if (dateA > dateB) {
                    var tempBookinglist = bookingList[j]
                    var tempSelectedList = selectedIDList[j]
                    var tempBlockCalenderList = BlockCalenderList[j]
                    bookingList[j] = bookingList[j + 1]
                    selectedIDList[j] = selectedIDList[j + 1]
                    BlockCalenderList[j] = BlockCalenderList[j + 1]
                    bookingList[j + 1] = tempBookinglist
                    selectedIDList[j + 1] = tempSelectedList
                    BlockCalenderList[j + 1] = tempBlockCalenderList
                }
            }
        }
        // console.log(bookingList)
        sessionStorage.setItem('bookArray', bookingList.length == 0 ? null : JSON.stringify(bookingList))

        setTimeout(() => {
            // console.log(JSON.parse(sessionStorage.getItem('bookArray')))
            // console.log(this.state.bookingList, selectedIDList, BlockCalenderList)
        }, 500);
    }

    clearSelected() {
        sessionStorage.removeItem('bookArray')
        sessionStorage.removeItem('validationDateList')
        sessionStorage.removeItem('centerID')
        this.setState({ bookingList: [], selectedIDList: [], selectedCenter: '', validationDateList: [], validationList: [], BlockCalenderList: [] })
    }

    onBook() {
        const { passClientID, bookingList, OrderID, venueId } = this.state
        const isEdit = this.props.location.state != null && this.props.location.state.isEdit != null ? this.props.location.state.isEdit : ''
        if (JSON.parse(sessionStorage.getItem('UserLoginData')) != null) {
            this.props.navigate('/companyInfo', { state: { Is_CenterID: true, OrderID: OrderID, CenterID: venueId, ClientID: passClientID, isEdit: isEdit } })
        }
        else {
            this.props.navigate('/login', { state: { companyInfo: true, Is_CenterID: true, isEdit: isEdit } })
        }
    }

    onClientSelect(clientID) {
        this.setState({ clientID: clientID })
        const { BlockCalenderList } = this.state
        // console.log(clientID)
        for (var i = 0; i < BlockCalenderList.length; i++) {
            BlockCalenderList[i].clientID = clientID
        }
        // console.log(BlockCalenderList)
    }

    handleBlockCalender() {
        const { BlockCalenderList, userID } = this.state
        this.setState({ isLoading: true })
        this.props.block_calender_action(BlockCalenderList, userID)
            .then((data) => {
                if (data.error != 1) {
                    toastSuccess("Blocked Successfully")
                    setTimeout(() => {
                        this.setState({ isLoading: false })
                        sessionStorage.removeItem('bookArray')
                        sessionStorage.removeItem('validationDateList')
                        // sessionStorage.removeItem('validationList')
                        this.setState({ bookingList: [], selectedIDList: [], selectedCenter: '', BlockCalenderList: [], clientID: '' })
                        this.toggleModal()
                        this.getCalender()
                    }, 300);

                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    toggleModal2() {
        const { isOpen2 } = this.state
        this.setState({ isOpen2: !isOpen2 })
    }

    toggleModal() {
        const { isOpen } = this.state
        this.setState({ isOpen: !isOpen })
        // if (ClientID == '') {
        //     return
        // }
        // else {
        //     this.setState({ clientDeleteId: ClientID })
        // }
    }

    currentDate(orDate) {
        const { currentDate, finalList } = this.state
        const options = { month: 'long', day: 'numeric', year: 'numeric' };
        var currDate = currentDate.toLocaleDateString(undefined, options);
        if (orDate != undefined) {
            var newDate = new Date(`${orDate.slice(3, 5)}/${orDate.slice(0, 2)}/${orDate.slice(6)}`)
            var newDate2 = newDate.toLocaleDateString(undefined, options)
        }
        if (currDate == newDate2) {
            return true
        }
    }

    onCenterSelect(data) {
        const { isSelectOpen } = this.state
        // console.log(data)
        this.setState({ isSelectOpen: !isSelectOpen })
        this.setState({ venueId: data.CenterID, venueName: data.Name, venueAddress: data.Location })
        setTimeout(() => {
            this.getCalender()
        }, 200);
    }
    renderSlots(data, day) {
        const { selectedCenter, blockedList, OrderID, selectedIDList } = this.state
        return (<>
            {day.eventListChild.length > 0 && day.eventListChild.map((event) => (<>
                {/* {console.log(event.ISITMEClient)} */}
                {(((event.status == 1 && event.isLock != 1) || event.orderID == OrderID) && !blockedList.includes(event.ID)) ? <div class="inputGroup">
                    <input
                        checked={selectedIDList.includes(event.ID)}
                        onClick={e => this.onSelect(e.target.value)} value={event.ID}
                        id={event.ID} name={event.ID} type="checkbox" />
                    <label for={event.ID} >{event.name}</label>
                </div> : <label class={'table_labels selected_color table_content_bg'}>{event.name}</label>}
            </>
            ))}
            {day.eventListChild.length > 0 && day.eventListParent.length > 0 && <div class={day.ISITMEClient == 1 ? 'text-white separator' : 'separator'}>OR</div>}
            {day.eventListParent.length > 0 && day.eventListParent.map((event) => (<>
                {(((event.status == 1 && event.isLock != 1) || event.orderID == OrderID) && !blockedList.includes(event.ID)) ? <div class="inputGroup">
                    <input
                        checked={selectedIDList.includes(event.ID)}
                        onClick={e => this.onSelect(e.target.value)} value={event.ID}
                        id={event.ID} name={event.ID} type="checkbox" />
                    <label for={event.ID} >{event.name}</label>
                </div> : <label class={'table_labels selected_color table_content_bg'}>{event.name}</label>}
            </>
            ))}
        </>)
    }
    render() {
        const { isLoading, holidayArr, OrderID, isSelectOpen, bookingList, BlockCalenderList, isOpen, userID, clientList, clientID, finalDayList, currentDate, selectedIDList, currentYear, blockedList, currentMonth, finalList, venueName, venueList, venueAddress, venueId, isOpen2 } = this.state
        const toInputUppercase = e => {
            e.target.value = ("" + e.target.value).toUpperCase();
        };

        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <ToastContainer />

                <main id="main">
                    <Header data={JSON.parse(sessionStorage.getItem('Is_modify')) != true && this.state.OrderID != null && this.state.OrderID != '' ? [3, true] : [3]} />
                    <section id="availability" class="availability" style={{ marginTop: '125px' }}>
                        {/* <div class="container-fluid"> */}
                        <div className="container-scroller" style={{ overflow: 'hidden' }}>
                            <div className="container-fluid page-body-wrapper full-page-wrapper">
                                {/* Left side menu */}
                                {/* <Drawer /> */}

                                {/* start page */}
                                <div class="calendar_view_data" style={{ marginBottom: '1rem' }}>
                                    <div class="card">
                                        <div class="card-body">
                                            <div id="wrap" style={{ position: "relative" }}>
                                                <div class="calender_facilityAndLocation">
                                                    {/* <div class='row'> */}
                                                    <h6><i class="fa fa-archive"></i> {venueName} - <span> <i class="fa fa-map-marker"></i> {venueAddress}</span>

                                                        {console.log(venueAddress, '<====')}
                                                        <span class="dropdown calendar_page_dropdown">
                                                            <button disabled={bookingList != 0 || OrderID != ''} onClick={() => this.setState({ isSelectOpen: !isSelectOpen })} class="btn btn-default dropdown-toggle" type="button" id="menu1" data-toggle="dropdown"><i class="fa fa-chevron-down"></i></button>
                                                            {isSelectOpen && <>
                                                                <div style={{ backgroundColor: 'white', border: 'solid 1px lightgrey', zIndex: '9999', position: 'absolute', right: '0', width: '200px' }}>
                                                                    {venueList.map((data) => (
                                                                        <li value={data.CenterID} style={{ listStyleType: 'none', cursor: 'pointer', padding: '8px', zIndex: '9999' }} onClick={e => this.onCenterSelect(data)} ><a><span>{data.Name}</span><br /><span><i class="fa fa-map-marker"></i> {data.Location}</span></a></li>
                                                                        // <option  >
                                                                        //     <br />
                                                                        //     </option>
                                                                    ))}
                                                                </div>
                                                            </>
                                                            }
                                                        </span>
                                                    </h6>

                                                    {/* <div class="col-md-2 mt-n2">
                                                <div class="form-group mb_0">
                                                    <select
                                                        className={"form-control"}
                                                        style={{ width: "100%" }}
                                                        // disabled={true}
                                                        value={venueId}
                                                        onChange={e => this.setState({ venueId: e.target.value })}
                                                    >
                                                        {venueList.length > 0 ? venueList.map(data => (
                                                            <option
                                                                key={data.CenterID}
                                                                value={data.CenterID}>
                                                                {data.Name}
                                                            </option>
                                                        )) : <></>}
                                                    </select>
                                                </div>
                                            </div> */}
                                                    {/* </div> */}
                                                    <div class="indications_labels calender_view">
                                                        <div class="label grey"><i class="fa fa-circle"></i> Booked</div>
                                                        <div class="label black"><i class="fa fa-circle"></i> Blocked</div>
                                                        <div class="label green"><i class="fa fa-circle"></i> Available</div>
                                                        <button onClick={this.clearSelected} type="button" class="clear_button" data-toggle="tooltip" data-placement="left" title="This will clear all the Selected Booking Dates">
                                                            clear
                                                        </button>
                                                    </div>
                                                </div>
                                                <div id='calender'>
                                                    <div class='header text-center'>
                                                        <span class="fc-header-title" ><h2>{currentMonth} {currentYear}</h2></span>
                                                        <span onClick={this.prevMonth} class="fc-button fc-button-prev fc-state-default fc-corner-left" unselectable="on"><span class="fc-text-arrow">‹</span></span>
                                                        <span onClick={this.nextMonth} class="fc-button fc-button-next fc-state-default fc-corner-right" unselectable="on"><span class="fc-text-arrow" >›</span></span>
                                                    </div>
                                                    <div class="table-responsive">
                                                        {console.log(this.state.currentMonthID, this.state.currentYear)}
                                                        <table className='fc-border-separate mt-1' style={{ width: '100%', }} cellSpacing={0}>
                                                            <thead>
                                                                <tr class="fc-first fc-last">
                                                                    {finalDayList.map((data) => (
                                                                        <th style={{ width: '14.28%' }}>{data}</th>
                                                                    ))}
                                                                </tr>
                                                            </thead>
                                                            {finalList.length != 0 ? <>
                                                                {finalList.map((data) => (
                                                                    <tbody>
                                                                        {data != undefined && data.week.map((date) => (
                                                                            <tr class="fc-week fc-first">
                                                                                {date.weekday.map((day) => (
                                                                                    <td className={day.ISITMEClient == 1 ? 'block_client fc-day2 fc-mon fc-widget-content fc-other-month fc-past fc-first' : 'fc-day fc-mon fc-widget-content fc-other-month fc-past fc-first'} id='fc-widget-content' >
                                                                                        <div style={{ minHeight: "120px" }}>
                                                                                            {this.currentDate(day.date) ?
                                                                                                <div style={{ marginLeft: '85%', backgroundColor: '#ff3b30', color: '#FFFFFF', borderRadius: '50%' }} class="fc-day-number mb-2">{day.date.slice(0, 2)}</div> :
                                                                                                <div style={{ marginLeft: '85%' }} class="fc-day-number mb-2">{day.date.slice(0, 2)}</div>}
                                                                                            {!holidayArr.includes(day.date) ? <>
                                                                                            {console.log(data)}
                                                                                                {(data.isSaturdayOff && day.dayName == "Saturday") || (data.isSundayOff && day.dayName == "Sunday") ? <label class="table_labels selected_color table_content_bg">MAINTENANCE DAY</label> :
                                                                                                    //     <> {this.renderSlots(data, days)}</>}
                                                                                                    // {(data.isSundayOff && days.dayName == "Sunday") ? <label class="table_labels selected_color table_content_bg">MAINTENANCE DAY</label> :
                                                                                                    //     <>{this.renderSlots(data, days)}</>
                                                                                                    <>{this.renderSlots(data, day)}</>}
                                                                                            </> : <label class="table_labels selected_color table_content_bg">MAINTENANCE DAY</label>}
                                                                                        </div>
                                                                                    </td>
                                                                                ))}
                                                                            </tr>
                                                                        ))
                                                                        }
                                                                    </tbody>
                                                                ))}</> : <>
                                                                <tbody> <tr class="fc-week fc-first"><td style={{ heght: '50px' }} colSpan={12} className='text-center'>Record not found</td></tr></tbody>
                                                            </>}

                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mr_0 mt-3">
                                        <div class="col-md-12 padding_0 text-right">
                                            {sessionStorage.getItem('blockAccess') == 1 && <button disabled={bookingList.length == 0} onClick={this.toggleModal} class="btn btn-warning custom_btn mr-2"><a style={{ color: 'white' }}>Block Calendar</a></button>}
                                            <button disabled={bookingList.length == 0
                                                //  && OrderID == ''
                                            } onClick={this.onBook} class="btn btn-primary custom_btn"><a>Book Now</a></button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* </div> */}
                    </section>
                </main>
                <Modal show={isOpen} onHide={this.toggleModal}>
                    <Modal.Header>
                        <Modal.Title><h4 class="modal-title modal_title_text">Add Client</h4></Modal.Title>
                        <button type="button " class="close pop-close" data-dismiss="modal" onClick={this.toggleModal} ><span aria-hidden="true" class="pop-cancel">&times;</span></button>
                    </Modal.Header>
                    <Modal.Body>
                        <div class="row">
                            <div class="form-group col-md-12">
                                <label for="inputZip">Client</label>
                                <div class="outside_input_field">
                                    {
                                        <input
                                            type="text"
                                            className="form-control"

                                            value={this.state.clientName}
                                            onChange={e => this.onClientSearch(e)}
                                            onInput={toInputUppercase}
                                        // onChange={this.changeUrl}
                                        />
                                    }
                                    {this.state.isDisplayClientList && this.renderClientList()}
                                    {/* {<span className='text-danger text-start text-left d-block mt-1'>{pinCodeErr}</span>} */}
                                    {/* <select
                                            className={"form-control"}
                                            style={{ width: "100%" }}
                                            // disabled={true}
                                            value={clientID}
                                            onChange={(e) => this.onClientSelect(e.target.value)}
                                        >
                                            <option>Select</option>
                                            {clientList.length > 0 ? clientList.map(data => (
                                                <option
                                                    key={data.ClientID}
                                                    value={data.ClientID}
                                                >
                                                    {data.Client}
                                                </option>
                                            )) : <></>}
                                        </select> */}
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div class="row">
                            <div class="col-md-12">
                                <a onClick={this.handleBlockCalender} class="btn save_btn">Apply</a>
                            </div>
                        </div>
                    </Modal.Footer>
                </Modal>
                <Modal show={isOpen2} onHide={this.toggleModal2}>
                    <Modal.Header>
                        {/* <Modal.Title><h4 class="">Note</h4></Modal.Title> */}
                    </Modal.Header>
                    <Modal.Body>
                        <div class="row">
                            <div class="form-group col-md-12">
                                <p>Date selection with a difference of more than a day at one time not allowed. In case of time spaced  multiple days session, you will have to fill different booking form.</p>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div class="row">
                            <div class="col-md-12">
                                <a onClick={this.toggleModal2} class="btn save_btn">OK</a>
                            </div>
                        </div>
                    </Modal.Footer>
                </Modal>
            </>

        );
    }
}

export default withRouter(connect(null, { search_calender_action, get_booking_Details_action, fill_action, block_calender_action })(CalenderView));